import React from 'react'
import './CodeFalconHero.scss'

export class CodeFalconHero extends React.Component {
  render() {
    return (
      <div
        className="code-falcon-page-hero"
        style={{ backgroundImage: 'url(/cloudsecopsbg.jpg)' }}
      >
        <div className="overlay" />
        <div className="inner-wrap">
          <div className="text">
            <h1>Code Falcon</h1>
            <h2>Secure Virtual Development Environments for DoD Engineers</h2>
          </div>
          <div className="logo-wrap">
            <img src="/code-falcon-logo.png" alt="Code Falcon Logo" className="code-falcon-logo" />
          </div>
        </div>
      </div>
    )
  }
}

export default CodeFalconHero
